import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const miSlice = createSlice({
  name: "mi",
  initialState: {
    load: false,
    page: "default",
    prevPage: "default",
    mode: "audit search",
    modes: ["audit search", "visualization"],
    pos: { x: window.innerWidth - 325, y: 100 },
    openContext: true,
    dateTime: moment(new Date()).format("MMM DD, YYYY hh:mm:ss a"),
    col_100: "rgba(245, 166, 35, 0.15)",
    col_300: "",
    col_500: "",
    col_700: "",
    col_900: "",
    color: "rgba(245, 166, 35, 1)"
  },
  reducers: {
    setLoading(state, action) {
      state.load = action.payload
    },
    setMode(state, action) {
      state.mode = action.payload;
    },
    changePage(state, action) {
      state.page = action.payload
    },
    setPrevPage(state, action) {
      // if a page is clicked twice, it won't update prev page
      if (state.page !== action.payload) {
        state.prevPage = action.payload
      }
    },
    updateDateTime(state, action) {
      state.dateTime = action.payload
    },
    setPos(state, action) {
      state.pos = action.payload
    },
    setopenContext(state, action) {
      state.openContext = action.payload
    },
    changeAccentColor(state, action) {
      state.color = action.payload;

      // calculating colour variants
      const r = action.payload.split("(")[1].split(",")[0];
      const g = action.payload.split("(")[1].split(",")[1];
      const b = action.payload.split("(")[1].split(",")[2].split(")")[0];
      
      state["col_100"] = `rgba(${r}, ${g}, ${b}, 0.15)`
    }
  }
})